import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#2563EB",       /* Primario Acción */
        secondary: "#1E3A8A",   /* Primario Oscuro */
        accent: "#F59E0B",
        info: "#0EA5E9",
        success: "#166534",     /* Éxito/Confirmado */
        warning: "#854D0E",     /* Alerta/Pendiente */
        error: "#991B1B",       /* Peligro/Crítico */
        background: "#F1F5F9", /* Fondo Sidebar */
        surface: "#FFFFFF",     /* Fondo Contenido */
        neutral: "#64748B",     /* Neutro/Borrador */
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
